import * as actions from './customerTag/actions'
import * as mutations from './customerTag/mutations'
import * as getters from './customerTag/getters'

import { dataProps } from './customerTag/properties'

const state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/customerTag.js